// extracted by mini-css-extract-plugin
module.exports = {"darkBg":"Agencies_darkBg__WU_cK","map":"Agencies_map___N1zB","leftArticle":"Agencies_leftArticle__OaDtL","article":"Agencies_article__yZJr9"};